import { render, staticRenderFns } from "./polygon5.vue?vue&type=template&id=39038ac4&"
import script from "./polygon5.vue?vue&type=script&lang=ts&"
export * from "./polygon5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports